import React from 'react';

const DividerItem = () => {
	return (
		<div className="flex h-3.5 shrink-0 items-center px-2">
			<div className="h-[2px] w-full bg-primary-dark"></div>
		</div>
	);
};

export default DividerItem;
